import React, { useState, useEffect } from 'react';
import { Table, Button, Modal, message } from 'antd';
import axiosInstance from '../../../axiosInstance';

// Get shopId from localStorage
const shopId = localStorage.getItem('shopId');

const InventoryPage = () => {
  const [inventory, setInventory] = useState([]);
  const [adjustments, setAdjustments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalData, setModalData] = useState([]);

  // Fetch Inventory and Adjustments
  const fetchInventoryData = async () => {
    setLoading(true);
    try {
      const response = await axiosInstance.get(`/inventory/${shopId}`);
      const { inventory, adjustments } = response.data;
      setInventory(inventory);
      setAdjustments(adjustments);
    } catch (error) {
      message.error('Error fetching inventory data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shopId) {
      fetchInventoryData();
    } else {
      message.error('No shop ID found');
    }
  }, []);

  // Handle Modal
  const openModal = (productName) => {
    const productAdjustments = adjustments.find(
      (adjustment) => adjustment.product_name === productName
    );
    if (productAdjustments) {
      setModalData(productAdjustments.adjustments);
      setModalVisible(true);
    } else {
      message.warning('No adjustments found for this product');
    }
  };

  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'product_name',
      key: 'product_name',
      width: 150,
    },
    {
      title: 'Batch',
      dataIndex: 'batch',
      key: 'batch',
      width: 100,
    },
    {
      title: 'Available Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      width: 150,
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Button type="link" onClick={() => openModal(record.product_name)}>
          View Adjustments
        </Button>
      ),
      width: 120,
    },
  ];

  // Modal table columns
  const modalColumns = [
    {
      title: 'Type',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Date Adjusted',
      dataIndex: 'date_adjusted',
      key: 'date_adjusted',
    },
  ];

  return (
    <div className="inventory-container">
      <style>
        {`
          .inventory-container {
            padding: 20px;
          }

          /* Responsive Table */
          @media (max-width: 768px) {
            .ant-table {
              font-size: 12px;
            }

            .ant-btn-link {
              font-size: 10px;
            }
          }

          /* Responsive Modal */
          @media (max-width: 576px) {
            .ant-modal {
              max-width: 90vw !important;
              margin: 0 auto;
            }
          }
        `}
      </style>
      <Table
        columns={columns}
        dataSource={inventory}
        loading={loading}
        rowKey="id"
        pagination={{ pageSize: 10 }}
        scroll={{ x: 800 }} // Enable horizontal scroll
      />

      {/* Modal for showing adjustments */}
      <Modal
        title="Product Adjustments"
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width="90vw"
        bodyStyle={{ overflow: 'auto', maxHeight: '70vh' }}
      >
        <Table
          columns={modalColumns}
          dataSource={modalData}
          rowKey={(record, index) => index}
          pagination={false}
          scroll={{ x: 500 }}
        />
      </Modal>
    </div>
  );
};

export default InventoryPage;
